import { defineComponent as L, ref as r, computed as s, watch as w, onMounted as M } from "vue";
import { padStart as f, parseInt as A } from "lodash-es";
import C from "./td-longtail-vue-components19.js";
import { useLabeledInput as P } from "./td-longtail-vue-components258.js";
import $ from "./td-longtail-vue-components26.js";
const N = /* @__PURE__ */ L({
  __name: "date-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    inlineLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { default: void 0 },
    minYear: { default: 1900 },
    maxYear: { default: (/* @__PURE__ */ new Date()).getFullYear() }
  },
  emits: ["input", "focus"],
  setup(h, { expose: S, emit: u }) {
    const a = h, { inputWrapperProps: Y, inputId: _, onInput: c, focus: m } = P(a, u);
    function i(e) {
      return { label: f(e.toString(), 2, "0"), value: e };
    }
    const o = r(null), n = r(null), l = r(null), d = (e) => {
      if (!e) {
        o.value = null, n.value = null, l.value = null;
        return;
      }
      const [t, x, D] = e.split("-").map(A);
      o.value = D, n.value = x, l.value = t;
    }, v = Array.from({ length: 31 }, (e, t) => i(t + 1)), y = Array.from({ length: 12 }, (e, t) => i(t + 1)), B = r({
      day: v,
      month: y
    }), I = s(() => !a.inlineLabel && !a.large && !a.medium), p = s(() => {
      if (!o.value || !n.value || !l.value) return null;
      const e = f(o.value.toString(), 2, "0"), t = f(n.value.toString(), 2, "0");
      return `${l.value}-${t}-${e}`;
    }), g = s(() => {
      const e = [];
      for (let t = a.maxYear; t >= a.minYear; t -= 1)
        e.push(t.toString());
      return e;
    });
    w(
      () => a.value,
      (e) => {
        d(e);
      }
    ), M(() => {
      d(a.value);
    });
    const b = () => {
      u("input", p.value);
    };
    return S({
      focus: m,
      onSelect: b,
      onInput: c,
      availableYears: g,
      dateDay: o,
      dateMonth: n,
      dateYear: l,
      dateString: p
    }), { __sfc: !0, props: a, emits: u, inputWrapperProps: Y, inputId: _, onInput: c, focus: m, buildOption: i, dateDay: o, dateMonth: n, dateYear: l, getDateFromString: d, DAYS: v, MONTHS: y, options: B, showInlineLabel: I, dateString: p, availableYears: g, onSelect: b, InputWrapper: C, SelectInput: $ };
  }
});
export {
  N as default
};
